import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reset-password" }
const _hoisted_2 = { class: "input-group" }
const _hoisted_3 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BaseSpinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", null, "Reset password", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BaseInput, {
              type: "password",
              name: "newpassword",
              modelValue: _ctx.v$.password.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.password.$model) = $event)),
              label: "New password",
              errors: _ctx.v$.password.$errors
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BaseInput, {
              type: "password",
              name: "passwordconfirm",
              modelValue: _ctx.v$.passwordConfirm.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.passwordConfirm.$model) = $event)),
              label: "Confirm password",
              errors: _ctx.v$.passwordConfirm.$errors
            }, null, 8, ["modelValue", "errors"])
          ]),
          _createVNode(_component_BaseButton, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Set password")
            ])),
            _: 1,
            __: [3]
          })
        ], 32))
  ]))
}